var map = {
	"./frame1.png": 4013,
	"./frame10.png": 5417,
	"./frame11.png": 9168,
	"./frame12.png": 2987,
	"./frame13.png": 8834,
	"./frame14.png": 4205,
	"./frame15.png": 3076,
	"./frame2.png": 2246,
	"./frame3.png": 6047,
	"./frame4.png": 8016,
	"./frame5.png": 2217,
	"./frame6.png": 4034,
	"./frame7.png": 5579,
	"./frame8.png": 1564,
	"./frame9.png": 3189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8608;